import KeyMomentChoiceContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/KeyMomentChoiceContent";
import HubEvent from "../../hub/event/HubEvent";
import KeyDecisionEvent from "../event/KeyDecisionEvent";
import KeyDecision from "./KeyDecision";
import KeyDecisionAnswer from "./KeyDecisionAnswer";
import KeyDecisionsConfig from "./KeyDecisionsConfig";

export default class KeyDecisionsModel {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {KeyDecisionsConfig} keyDecisionsConfig 
     */
    constructor(dispatcher, keyDecisionsConfig) {
        this._dispatcher = dispatcher;
        this._keyDecisionsConfig = keyDecisionsConfig;

        /** @type {Array<KeyDecision>} */
        this._availableKeyDecisions = [];
        /** @type {Array<KeyDecision>} */
        this._completedKeyDecisions = [];
        /** @type {Array<KeyMomentChoiceContent>} */
        this._lockedOptionsKeyDecisions = [];
    }

    get completedKeyDecisions() {
        return this._completedKeyDecisions;
    }
    clearKeyDecisions() {
        this._availableKeyDecisions = [];
        this._completedKeyDecisions = [];
    }

    getNumberKeyDecisionByChapter(chapter) {
        return this._keyDecisionsConfig.getKeyDecisionsByChapter(chapter).length;
    }

    getAvailableKeyDecisionByContent(content) {
        return this._availableKeyDecisions.find(kd => kd.content === content);
    }

    /**
     * @param {KeyDecision} keyDecision 
     */
    makeKeyDecisionAvailable(keyDecision) {
        this._availableKeyDecisions.push(keyDecision);

        const keyDecisionEvent = new KeyDecisionEvent(KeyDecisionEvent.KEY_DECISION_AVAILABLE, keyDecision);
        this._dispatcher.dispatch(keyDecisionEvent.type, { data: keyDecisionEvent });

        this._dispatcher.dispatch(HubEvent.REFRESH_KEY_DECISIONS_LIST);
    }

    /**
     * @param {KeyDecision} keyDecision 
     */
    makeKeyDecisionUnavailable(keyDecision) {
        const keyDecisionIndex = this._availableKeyDecisions.indexOf(keyDecision);
        if (keyDecisionIndex === -1) {
            console.error(`[KeyDecisionsModel] Cannot make a key decision unavailable if it isn't available.`);
            return;
        }

        this._availableKeyDecisions.splice(keyDecisionIndex, 1);

        const keyDecisionEvent = new KeyDecisionEvent(KeyDecisionEvent.KEY_DECISION_UNAVAILABLE, keyDecision);
        this._dispatcher.dispatch(keyDecisionEvent.type, { data: keyDecisionEvent });
    }

    /**
     * @param {KeyDecision} keyDecision 
     */
    completeKeyDecision(keyDecision) {
        this._completedKeyDecisions.push(keyDecision);

        const keyDecisionEvent = new KeyDecisionEvent(KeyDecisionEvent.KEY_DECISION_COMPLETED, keyDecision);
        this._dispatcher.dispatch(keyDecisionEvent.type, { data: keyDecisionEvent });
    }

    /**
     * @param {KeyMomentChoiceContent} content 
     */
    saveGoodLockedOptionsKeyDecisions(content) {
        if(content.getType() !== KeyMomentChoiceContent.TYPE || content.getSituationDescription() !== KeyDecisionAnswer.GOOD_RATING) {
            return;
        }
        this._lockedOptionsKeyDecisions.push(content);
    }

    getGoodLockedOptionsKeyDecisions() {
        return this._lockedOptionsKeyDecisions;
    }

    getGoodLockedOptionsKeyDecisionsWithPrefix(prefix) {
        return this._lockedOptionsKeyDecisions.filter(kd => kd.getKeyMomentID().startsWith(prefix));
    }
}